import { Capacitor } from '@capacitor/core';

export const APP_URL = 'https://leaguehub.it';
export const appUrl = (path) => `${APP_URL}${path}`;

export const isInstalledApp = () => Capacitor.isNativePlatform() || (
  typeof window !== 'undefined' && (
    window.matchMedia?.('(display-mode: standalone)').matches ||
    window.navigator?.standalone === true
  )
);

// ponytail: Apple 3.1.1 / Play billing — niente acquisto Premium via Stripe nei wrapper nativi, si compra dal web.
export const canSellPremium = () => !Capacitor.isNativePlatform();

export function appLinkPath(value) {
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || !['leaguehub.it', 'www.leaguehub.it'].includes(url.host)) return null;
    if (!/^\/(matches|leagues|competitions|p)\/[^/]+\/?$/.test(url.pathname)) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}
